import { CandidatesList } from "../candidatesList"
import { FavoriteCandidatesTabProps } from "./model"

export const FavoriteCandidatesTab = (props: FavoriteCandidatesTabProps) => {
    return (
        <div id="available-job-title" className="h-full">
            <div className="mt-[16px] sm:mt-[32px] h-full">
                <CandidatesList url="candidates" candidates={props.candidates} loading={props.loading} emptyMessage="Nu ai candidați favoriți încă." />
            </div>
        </div>
    )
}